import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import addIcon from "../../assets/images/addIcon.svg";
import * as Yup from "yup";
import chooseBrandSvg from "../../assets/images/choose-brand.svg";
import angleRightSvg from "../../assets/images/angle_right.svg";
import exclamatorIcon from "../../assets/images/exclamatorIcon.svg";
import locationIconSvg from "../../assets/images/location-icon.svg";
import closeSvg from "../../assets/images/close_cross_icon.svg";
import { format, addMonths, subMonths } from "date-fns";
import api from "../../services/api";
import { useForm, Controller } from "react-hook-form";
import { Toast } from "../../shared/Toast";
import Select from "react-select";
import Datepicker from "react-tailwindcss-datepicker";
import { data } from "autoprefixer";
import {
  billingOptions,
  slotBooking_campaign_types,
  langoptions,
  roles,
  slotBookingCreativeTypes,
  slotPackages,
  slotPackagesOptions,
  slotPaymentMethodOptions,
  slotPaymentTypeOptions,
  slotPositions,
  localTypes,
  getNumberOfDays,
  getNumberOfDaysForNormalDays,
  BrandsTypes,
  dealTypeOptions,
} from "../../utils/constants";
import PdfViewer from "../Orders/PdfViewer";
import { formatDateDDMMYYY, formatDateYYYYMMDD } from "../../utils/dateFormat";
import config from "../../config";
import { useSelector } from "react-redux";
import SubFormBook, { subFormInitialValues } from "./SubFormBook";

let languageOptions = langoptions;
let positionOptions = slotPositions.map((item) => {
  return { label: item === -1 ? "SOV" : item, value: item };
});
let slotOptions = [
  { label: "A", value: 0 },
  { label: "B", value: 1 },
];
if (localStorage.getItem("role") === roles.ops) {
  slotOptions.push({ label: "C", value: 2 });
}

let packageOptions = [
  { label:"No Package", value: 0}, 
  { label:"Package", value: 1},
  // { label:"Zone Package", value:2}
];

let PackageTypes = [
  { label:"Local", value:"Local"},
  { label:"Alpha", value:"Alpha"},
  { label:"Classified", value:"Classified"},
]

let InboundPackageTypes = [
  { label:"Inbound", value:"Inbound"},
  { label:"Classified", value:"Classified"},
]
function BookSlot(props) {
  const reduxNew_user_type = useSelector((state) => state.Head.new_user_type);
  const [new_user_type, setNew_user_type] = useState(reduxNew_user_type);
  const [editInitialCall, seteditInitialCall] = useState(true);
  const [assignedBrands, setAssignedBrands] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const navigate = useNavigate();
  const [roFileUrl, setRoFileUrl] = useState(null);
  const [nonBillFileUrl, setNonBillFileUrl] = useState(null);
  const [pdcFileUrl, setPdcFileUrl] = useState(null);
  const [campaign_certificateUrl, setCampaign_certificateUrl] = useState(null);
  const [progress, setProgress] = useState(0);
  const [nonBillingFileProgress, setNonBillingFileProgress] = useState(0);
  const [pdcFileprogress, setPdcFileprogress] = useState(0);
  const [flag, setFlag] = useState(false);
  const [mostActive, setMostActive] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [mandalOptions, setMandalOptions] = useState([]);
  const [villageOptions, setVillageOptions] = useState([]);
  const [constituencyOptions, setConstituencyOptions] = useState([]);
  const [viewPdf, setViewPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [action, setAction] = useState(
    props.editItem?.action === "edit" ? "edit" : "add"
  );
  const [editData, setEditData] = useState(null);
  const [priceErr, setPriceErr] = useState(false);
  const [tempcpd, setTempcpd] = useState(0);
  const [salesList, setSalesList] = useState([]);
  const [daysMismatched, setDaysMismatched] = useState(false);
  const [currentPage, setCurrentPage] = useState("A");
  const [formikBSubFormValues, setFormikBSubFormValues] = useState([
    { ...subFormInitialValues, internal_id: 0 },
  ]);
  const [formikBSubFormErrors, setFormikBSubFormErrors] = useState([]);
  const [formikBTouchedFlag, setFormikBTouched] = useState(false);
  const [formikBSaveFlag, setFormikBSaveFlag] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [submitLoader, setSubmitLoader] = useState(false)
  const [creativeImageUrl, setCreativeImageUrl] = useState(null);
  const [creativeImageProgress, setCreativeImageProgress] = useState(0);

  const formikA = useFormik({
    initialValues: {
      slot_name: "",
      sales_person_id: 0,
      brand_id: 0,
      company_id: 0,
      tag: "",
      package_order:0,
      package_type:null,
      image_url:"",
    },
    validationSchema: Yup.object({
      slot_name: Yup.string().required("Order Name is required"),
      sales_person_id:
        localStorage.getItem("role") === roles.ops
          ? Yup.number()
              .min(1, "Sales person Required")
              .required("Sales person Required")
          : Yup.number().optional(),
      brand_id: Yup.number()
        .positive()
        .min(1, "Brand is Required")
        .required("Brand is required"),
      company_id: Yup.number()
        .positive()
        .min(1, "Company is Required")
        .required("Company is required"),
      tag: Yup.string().optional()
    }),
    onSubmit: async (values) => {
      setCurrentPage("B");
    },
  });
  const formikB = useFormik({
    initialValues: {},
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      let free = true;
      formikBSubFormErrors.map((eachFormErrors) => {
        if (Object.keys(eachFormErrors).length) {
          free = false;
          return;
        }
      });
      if (free) setCurrentPage("C");
    },
  });

  const formikC = useFormik({
    initialValues: {
      payment_id: "",
      package_no: "1",
      deal_type: 1,
      payment_type:
        new_user_type === 1
          ? 2
          : new_user_type === 5
          ? 1
          : localTypes.includes(new_user_type)
          ? 0
          : 0,
      payment_method: new_user_type === 1 ? 4 : 0,
      pdcfile_url: "",
      nonbillfile_url: "",
      billing: 1,
      description: "",
      ro_value: "",
      rofile_url: "",
    },
    validationSchema: Yup.object({
      rofile_url: Yup.string(),
      ro_value: Yup.number("Please Enter Ro Value")
        .positive()
        .min(1, "Please Enter Ro Value")
        .required("Please Enter Ro Value"),
      description: Yup.string().optional(),
      billing: Yup.number().required("Required Field"),
      nonbillfile_url: Yup.string().when("billing", {
        is: (value) => value === 0,
        then: Yup.string().required("Non Billing Reason is required"),
        otherwise: Yup.string(),
      }),

      payment_id: Yup.string().required("Required"),
      package_no: Yup.number().required("Required"),
      payment_type: Yup.number()
        .min(1, "Payment type Required")
        .required("Payment type Required"),
      payment_method: Yup.number().when("payment_type", {
        is: (value) => value === 1,
        then: Yup.number()
          .min(1, "Payment type Required")
          .required("Payment method is required"),
        otherwise: Yup.number(),
      }),
      pdcfile_url: Yup.string().when("payment_type", {
        is: (value) => value === 3,
        then: Yup.string().required("PDC File required"),
        otherwise: Yup.string(),
      }),
    }),
    onSubmit: async (values) => {
      setSubmitLoader(true)
      let finalFormikBSubFromValues = JSON.parse(
        JSON.stringify(formikBSubFormValues)
      );
      if (action === "edit") {
        let previousIntIds = editData.internal_details.map(
          (internalItem) => internalItem.internal_id
        );
        finalFormikBSubFromValues.map((InternalItem) => {
          if (!previousIntIds.includes(InternalItem.internal_id)) {
            delete InternalItem.internal_id;
          }
        });
      }

      values = {
        ...formikA.values,
        internalDetails: finalFormikBSubFromValues,
        image_url: creativeImageUrl,
        ...values,
      };
      if (localStorage.getItem("role") !== roles.ops)
        delete values.sales_person_id;
      values.payment_type = new_user_type === 1 ? 2 : values.payment_type;
      values.payment_method = new_user_type === 1 ? 4 : values.payment_method;
      values.package_no = new_user_type === 5 ? values.package_no : "1";
      let reqObj = {
        ...values,
      };
      if (action === "add") {
        let addResult = await api({
          url: "/slotbooking/add-slot",
          method: "POST",
          data: reqObj,
          responseType: "json",
        });
        if (addResult.code === 200) {
          Toast("success", "Successfully Inserted");
          formikA.resetForm();
          formikB.resetForm();
          formikC.resetForm();
          setEditData(null);
          props.setShow(false);
        } else {
          Toast("error", addResult.data.message);
        }
      } else {
        reqObj.slot_id = editData.slot_id;
        let editResult = await api({
          url: "/slotbooking/edit-slot",
          method: "POST",
          data: reqObj,
          responseType: "json",
        });
        if (editResult.code === 200) {
          Toast("success", "Successfully Updated");
          formikA.resetForm();
          formikB.resetForm();
          formikC.resetForm();
          setEditData(null);
          props.setShow(false);
        } else {
          Toast("error", editResult.data.message);
        }
      }
      setSubmitLoader(false)
    },
  });

  const fetchBrands = async () => {
    try {
      let res = await api({
        url: "/slotbooking/get-brands",
        method: "POST",
        responseType: "json",
        data: {
          sales_person_id: formikA.values.sales_person_id
            ? formikA.values.sales_person_id
            : undefined,
        },
      });
      if (res.code === 200) {
        setAssignedBrands(res.data);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };
  const loadCompany = async () => {
    try {
      const response = await api({
        url: `/order/fetch-companies`,
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (response?.data) {
        setCompaniesList(response?.data);
      }
      setInitialRender(false);
    } catch (error) {
      console.log("error @ loadCompany", error);
    }
  };

  const getSalesList = async () => {
    try {
      let salesListResponse = await api({
        url: "/user/sales_persons/getSalesUsers",
        method: "POST",
        responseType: "json",
      });
      if (salesListResponse.code === 200) {
        setSalesList(salesListResponse.data);
      }
    } catch (error) {
      console.log("Error @ getSalesList", error);
    }
  };

  const handlePackageOrderChange = (selected) =>{
      formikA.setFieldValue('package_order', selected?.value);
      if(selected?.value === 0) {
        formikA.setFieldValue('package_type',null);
      }else if(selected?.value === 1){
        if(new_user_type === 9) formikA.setFieldValue('package_type',"Inbound");
        else formikA.setFieldValue('package_type',"Local");
      }

      formikB.setFieldValue('pakage_value',null)
      formikB.setFieldValue('lang_ids',[])
      formikB.setFieldValue('state_ids',[])
      formikB.setFieldValue('district_ids',[])
      formikB.setFieldValue('constituency_ids',[])
      formikB.setFieldValue('zone_ids',[])
  }
  const handlePackageTypeChange = (selected) => {
    
      formikA.setFieldValue('package_type', selected?.value);
      formikB.setFieldValue('pakage_value',null)
      formikB.setFieldValue('lang_ids',[])
      formikB.setFieldValue('state_ids',[])
      formikB.setFieldValue('district_ids',[])
      formikB.setFieldValue('constituency_ids',[])
      formikB.setFieldValue('zone_ids',[])
  }
  const packageTypes = new_user_type === 9 ? InboundPackageTypes : PackageTypes;
  
  const editAction = async (editItem) => {
    let {
      date_ranges,
      lang_ids,
      state_Objs,
      district_Objs,
      constituency_Objs,
      mandal_Objs,
      rofile_url,
      positions,
      slot,
      brand_id,
      ro_value,
      description,
      action,
      company_id,
      creative_type,
      billing,
      nonbillfile_url,
      slot_name,
      tag,
      payment_id,
      payment_type,
      deal_type,
      payment_method,
      package_no,
      campaign_type,
      sales_price,
      sales_person_id,
      pdcfile_url,
      new_user_type,
      internal_details,
    } = editItem;
    if (date_ranges?.length) {
      let tempInternalDetails = [
        {
          ...subFormInitialValues,
          date_ranges: date_ranges.map((item) => {
            return {
              startDate: formatDateYYYYMMDD(item.start_date),
              endDate: formatDateYYYYMMDD(item.end_date),
            };
          }),
        },
      ];
      setFormikBSubFormValues(tempInternalDetails);
    }
    if (action === "edit") {
      formikA.setFieldValue("slot_name", slot_name);
      formikA.setFieldValue("tag", tag);
      formikA.setFieldValue("sales_person_id", sales_person_id);
      formikA.setFieldValue("brand_id", brand_id);
      formikA.setFieldValue("company_id", company_id);
      internal_details.map((internalItem) => {
        internalItem.state_ids = internalItem.state_Objs;
        internalItem.district_ids = internalItem.district_Objs;
        internalItem.constituency_ids = internalItem.constituency_Objs;
        internalItem.mandal_ids = internalItem.mandal_Objs;
        // delete internalItem.state_Objs;
        // delete internalItem.district_Objs;
        // delete internalItem.constituency_Objs;
        // delete internalItem.mandal_Objs;
        internalItem.date_ranges = internalItem.date_ranges.map((item) => {
          return {
            startDate: formatDateYYYYMMDD(item.start_date),
            endDate: formatDateYYYYMMDD(item.end_date),
          };
        });
      });
      setFormikBSubFormValues(internal_details);
      setFormikBSubFormErrors([]);

      formikC.setFieldValue("payment_id", payment_id);
      formikC.setFieldValue("payment_type", payment_type);
      formikC.setFieldValue("deal_type", deal_type);
      formikC.setFieldValue("payment_method", payment_method);
      formikC.setFieldValue("package_no", "" + package_no);
      formikC.setFieldValue("rofile_url", rofile_url);
      setRoFileUrl(rofile_url);
      formikC.setFieldValue("pdcfile_url", pdcfile_url);
      setPdcFileUrl(pdcfile_url);
      formikC.setFieldValue("billing", billing);
      formikC.setFieldValue("nonbillfile_url", nonbillfile_url);
      setNonBillFileUrl(nonbillfile_url);
      formikC.setFieldValue("ro_value", ro_value);
      formikC.setFieldValue("description", description);
      setNew_user_type(new_user_type === -1 ? 1 : new_user_type);
    }
  };
  useEffect(() => {
    if (props.editItem) {
      editAction(props.editItem);
      setEditData(props.editItem);
    }
    if (localStorage.getItem("role") === roles.ops) {
      getSalesList();
    }
    fetchBrands();
    loadCompany();
  }, []);
  const defaultValue = (options, value) => {
    return options
      ? options.find((option) => option.value === value) || null
      : null;
  };

  const onSalesPersonChange = async (sales_person_id) => {
    let tempnew_user_type = salesList.find(
      (item) => item.value === +sales_person_id
    )?.new_user_type;
    tempnew_user_type = tempnew_user_type === -1 ? 1 : tempnew_user_type;
    if (tempnew_user_type) {
      setNew_user_type(tempnew_user_type);
      formikC.setFieldValue(
        "payment_type",
        tempnew_user_type === 1
          ? 2
          : tempnew_user_type === 5
          ? 1
          : localTypes.includes(tempnew_user_type)
          ? 0
          : 0
      );
      formikC.setFieldValue("payment_method", tempnew_user_type === 1 ? 4 : 0);
    }
  };
  const uploadroFile = async (formData, fileType) => {
  try {
    const res = await api({
      url: fileType === "creative_image" ? "/upload/image" : "/upload/file-upload",
      method: "POST",
      responseType: "json",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (data) => {
        const percentage = Math.round((100 * data.loaded) / data.total);
        if (fileType === "rofile_url") setProgress(percentage);
        else if (fileType === "nonbillfile_url") setNonBillingFileProgress(percentage);
        else if (fileType === "pdcfile_url") setPdcFileprogress(percentage);
        else if (fileType === "creative_image") setCreativeImageProgress(percentage);
      },
    });

    if (res.code === 200) {
      const uploadedUrl = res.data?.data;

      if (fileType === "rofile_url") {
        setRoFileUrl(uploadedUrl);
        formikC.setFieldValue("rofile_url", uploadedUrl);
      }
      if (fileType === "nonbillfile_url") {
        setNonBillFileUrl(uploadedUrl);
        formikC.setFieldValue("nonbillfile_url", uploadedUrl);
      }
      if (fileType === "pdcfile_url") {
        setPdcFileUrl(uploadedUrl);
        formikC.setFieldValue("pdcfile_url", uploadedUrl);
      }
      if (fileType === "creative_image") {
        setCreativeImageUrl(uploadedUrl);
        formikC.setFieldValue("image_url", uploadedUrl);
        Toast("success", "Image uploaded successfully");
      } else if (fileType !== "creative_image") {
        Toast("success", "File uploaded successfully");
      }
    }
  } catch (error) {
    console.error(error);
    Toast("error", "Upload failed");
  }
};
  const handleFileChange = async (e, fileType) => {
    if (e.target.files.length) {
      const formData = new FormData();
      formData.append("files", e.target.files[0]);
      await uploadroFile(formData, fileType);
    } else {
      if (flag === "edit") {
        setRoFileUrl(roFileUrl);
        setNonBillFileUrl(nonBillFileUrl);
        setCampaign_certificateUrl(campaign_certificateUrl);
        setPdcFileUrl(pdcFileUrl);
      } else {
        setRoFileUrl("");
        setNonBillFileUrl("");
        setCampaign_certificateUrl("");
        setPdcFileUrl("");
      }
    }
  };
  function convertToWords(price) {
    const sglDigit = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const dblDigit = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tensPlace = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const handle_tens = function (dgt, prevDgt) {
      return 0 === dgt
        ? ""
        : " " + (1 === dgt ? dblDigit[prevDgt] : tensPlace[dgt]);
    };
    const handle_utlc = function (dgt, nxtDgt, denom) {
      return (
        (0 !== dgt && 1 !== nxtDgt ? " " + sglDigit[dgt] : "") +
        (0 !== nxtDgt || dgt > 0 ? " " + denom : "")
      );
    };

    let str = "";
    let digitIdx = 0;
    let digit = 0;
    let nxtDigit = 0;
    const words = [];
    if (((price += ""), isNaN(parseInt(price)))) str = "";
    else if (parseInt(price) > 0 && price.length <= 10) {
      for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--) {
        digit = price[digitIdx] - 0;
        nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0;
        switch (price.length - digitIdx - 1) {
          case 0:
            words.push(handle_utlc(digit, nxtDigit, ""));
            break;
          case 1:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 2:
            words.push(
              0 !== digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 !== price[digitIdx + 1] && 0 !== price[digitIdx + 2]
                      ? " and"
                      : "")
                : ""
            );
            break;
          case 3:
            words.push(handle_utlc(digit, nxtDigit, "Thousand"));
            break;
          case 4:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 5:
            words.push(handle_utlc(digit, nxtDigit, "Lakh"));
            break;
          case 6:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 7:
            words.push(handle_utlc(digit, nxtDigit, "Crore"));
            break;
          case 8:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 9:
            words.push(
              0 !== digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 !== price[digitIdx + 1] || 0 !== price[digitIdx + 2]
                      ? " and"
                      : " Crore")
                : ""
            );
            break;
          default:
            break;
        }
      }
      str = words.reverse().join("");
    } else str = "";
    return str;
  }
  useEffect(() => {
    fetchBrands();
    // fetchMostActive();
  }, [formikA.values.sales_person_id]);
  useEffect(() => {
    let { brand_id, company_id } = formikA.values;
    if (brand_id && company_id && !initialRender) {
      // let start_date = new Date(`${date_ranges[0].startDate}T00:00:00+05:30`);
      // start_date = Math.floor(new Date(start_date).getTime() / 1000);
      // let tempDate = new Date(start_date * 1000);
      let brand_name =
        assignedBrands.find((item) => item.value === brand_id)?.label || "";
      let agency_name =
        companiesList.find((item) => item.value === company_id && item.isagency)
          ?.label || "";
      formikA.setFieldValue(
        "slot_name",
        `${BrandsTypes.find((item) => item.value === +new_user_type).label}_${
          new_user_type === 1 ? "" : agency_name ? `${agency_name}_` : "Direct_"
        }${brand_name}`
      );
    }
    // _${
    //   new_user_type === 1
    //     ? `${format(tempDate, "MMM")}_${format(tempDate, "yyyy")}`
    //     : formatDateDDMMYYY(start_date)
    // }
  }, [formikA.values.brand_id, new_user_type, formikA.values.company_id]);
  return (
    <div id="bookSlotModal">
      {/* {console.log(
        "Berrors",
        formikB.errors,
        "\nvalues",
        formikB.values,
        "\nnew_user_type",
        new_user_type,
        currentPage
      )} */}

      <form
        className={currentPage === "A" ? `` : "displaynone"}
        onSubmit={formikA.handleSubmit}
      >
        <div className="pos-popup-container">
          <div className="pos-popup-header">
            <h3>
              Book Order{" "}
              <b>
                {localStorage.getItem("role") === roles.ops
                  ? null
                  : localStorage.getItem("name")}
              </b>
            </h3>
            <span className="close2">
              <img
                src={closeSvg}
                onClick={() => {
                  props.setShow(false);
                  formikA.resetForm();
                  setEditData(null);
                }}
                alt="Close"
              />
            </span>
          </div>

          <div className="pos-popup-body">
            <div className="form-container">
              <div className="field-set-tree">
                <div class="progress-bar">
                  <div class="step active">
                    <div class="tabhead">Details</div>
                    <div class="numaric"></div>
                  </div>
                  <div class="step">
                    <div class="tabhead">Add Unit</div>
                    <div class="numaric"></div>
                  </div>
                  <div class="step">
                    <div class="tabhead">Payment Details</div>
                    <div class="numaric"></div>
                  </div>
                </div>
                {/* <h4>
                  <img src={chooseBrandSvg} alt="" /> Choose Brand &amp; Company
                </h4> */}
                <div className="bookPosition mb-8">
                  {localStorage.getItem("role") === roles.ops ? (
                    <div className="ind">
                      <h6>
                        Sales Person <span className="text-red-600">*</span>
                      </h6>
                      <Select
                        // class="form-select"
                        aria-label="Default select example"
                        name="brand_id"
                        placeholder="Select a Sales Person"
                        onBlur={formikA.handleBlur}
                        value={defaultValue(
                          salesList,
                          formikA.values.sales_person_id
                        )}
                        onChange={(selected) => {
                          formikA.setFieldValue(
                            "sales_person_id",
                            selected.value
                          );
                          formikA.setFieldValue('package_order',0)
                          formikA.setFieldValue('package_type',null)
                          formikA.setFieldValue("brand_id", 0);
                          onSalesPersonChange(selected.value);
                          formikA.setFieldValue("slot_name", "");
                        }}
                        options={salesList}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isDisabled={action === "edit"}
                      />
                      {formikA.touched.sales_person_id &&
                        formikA.errors.sales_person_id && (
                          <span
                            id="formikError"
                            className="text-red-500 text-xs"
                          >
                            {formikA.errors.sales_person_id}
                          </span>
                        )}
                    </div>
                  ) : null}
                  <div className="ind">
                    <h6>
                      Brand <span className="text-red-600">*</span>
                    </h6>
                    <Select
                      // class="form-select"
                      aria-label="Default select example"
                      name="brand_id"
                      placeholder="Select a Brand"
                      onBlur={formikA.handleBlur}
                      value={
                        defaultValue(assignedBrands, formikA.values.brand_id) ||
                        null
                      }
                      onChange={(selected) =>
                        formikA.setFieldValue("brand_id", selected.value)
                      }
                      options={assignedBrands}
                      classNamePrefix="select"
                    />
                    {formikA.touched.brand_id && formikA.errors.brand_id && (
                      <span id="formikError" className="text-red-500 text-xs">
                        {formikA.errors.brand_id}
                      </span>
                    )}
                  </div>
                </div>
                <div className="bookPosition mb-2">
                  <div className="ind">
                    {" "}
                    <h6>
                      Company <span className="text-red-600">*</span>
                    </h6>
                    <Select
                      aria-label="Default select example"
                      name="company_id"
                      placeholder="Select a Company"
                      onBlur={formikA.handleBlur}
                      value={defaultValue(
                        companiesList,
                        formikA.values.company_id
                      )}
                      onChange={(selected) =>
                        formikA.setFieldValue("company_id", selected.value)
                      }
                      options={companiesList}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                    {formikA.touched.company_id &&
                      formikA.errors.company_id && (
                        <span id="formikError" className="text-red-500 text-xs">
                          {formikA.errors.company_id}
                        </span>
                      )}
                  </div>
                  <div className="ind">
                    <h6 className="whitespace-nowrap">Order Name</h6>
                    <input
                      type="text"
                      name="slot_name"
                      placeholder="Enter Name"
                      onChange={formikA.handleChange}
                      onBlur={formikA.handleBlur}
                      value={formikA.values.slot_name}
                      className="border_bottom cursor-not-allowed text-lg w-full bg-gray-200"
                      disabled={true}
                    />
                    {/* <p className="text-xs text-gray-400">
                      At the end of Order Name please mention Start date of
                      Order
                    </p> */}
                    {formikA.touched.slot_name && formikA.errors.slot_name ? (
                      <span id="formikError" className="text-red-500 text-xs">
                        {formikA.errors.slot_name}
                      </span>
                    ):null}
                  </div>                  
                </div>
                <div className="bookPosition mb-2">
                    <div className="ind">
                      <h6 className="whitespace-nowrap">Tag</h6>
                      <input
                        type="text"
                        name="tag"
                        placeholder="Enter tag"
                        onChange={formikA.handleChange}
                        onBlur={formikA.handleBlur}
                        value={formikA.values.tag}
                        className="border_bottom text-lg w-full"
                      />
                      {formikA.touched.tag && formikA.errors.tag && (
                        <span id="formikError" className="text-red-500 text-xs">
                          {formikA.errors.tag}
                        </span>
                      )}
                    </div>
                </div>
                <div className="bookPosition mb-2">
                    <div className="flex mt-4 gap-3 flex-col px-2 py-1">
                      <label className="text-black"> Package Order</label>
                      <Select value = {packageOptions.find(item=> item.value === formikA?.values?.package_order)} options={packageOptions} onChange={handlePackageOrderChange} />
                    </div>
                    <div className="flex gap-3 items-center justify-center text-black">
                      {formikA?.values?.package_order ? (
                        <div className="flex flex-col mt-4 gap-3 px-2 py-1">
                          <label className="text-black">Package Type</label>
                          <Select value = {packageTypes.find(item=> item.value === formikA?.values?.package_type)} options={packageTypes} onChange={handlePackageTypeChange} />
                        </div>
                      ):null}
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pos-popup-footer">
            <button
              type="button"
              className="close btn-cancel"
              onClick={() => {
                props.setShow(false);
                formikA.resetForm();
                formikB.resetForm();
                formikC.resetForm();
                setEditData(null);
              }}
            >
              <span className="back-btn">Cancel</span>
            </button>
            <button
              className="btn-submit"
              type="submit"
              onClick={() =>
                document
                  ?.getElementById("formikError")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              <span>Next</span> <img src={angleRightSvg} alt="submit" />
            </button>
          </div>
        </div>
      </form>

      <form
        className={currentPage === "B" ? `` : "displaynone"}
        onSubmit={(e) => {
          setFormikBSaveFlag(!formikBSaveFlag);
          setFormikBTouched(!formikBTouchedFlag);
          formikB.handleSubmit(e);
        }}
      >
        <div className="pos-popup-container">
          <div className="pos-popup-header">
            <h3>
              Book Order{" "}
              <b>
                {localStorage.getItem("role") === roles.ops
                  ? null
                  : localStorage.getItem("name")}
              </b>
            </h3>
            <span className="close2">
              <img
                src={closeSvg}
                onClick={() => {
                  props.setShow(false);
                  formikA.resetForm();
                  formikB.resetForm();
                  formikC.resetForm();
                  setEditData(null);
                }}
                alt="Close"
              />
            </span>
          </div>

          <div className="pos-popup-body">
            <div className="form-container">
              <div className="field-set-tree">
                <div class="progress-bar">
                  <div class="step active">
                    <div class="tabhead">Details</div>
                    <div class="numaric"></div>
                  </div>
                  <div class="step active">
                    <div class="tabhead">Add Unit</div>
                    <div class="numaric"></div>
                  </div>
                  <div class="step">
                    <div class="tabhead">Payment Details</div>
                    <div class="numaric"></div>
                  </div>
                </div>
                {formikBSubFormValues.map((subFormValue, index) => {
                  return (
                    <div className="mainbox">
                      <SubFormBook
                        formikB={formikB}
                        index={index}
                        key={subFormValue.internal_id}
                        nextClicked={formikBTouchedFlag}
                        new_user_type={new_user_type}
                        saveChanges={formikBSaveFlag}
                        formikBSubFormValues={formikBSubFormValues}
                        setFormikBSubFormValues={setFormikBSubFormValues}
                        formikBSubFormErrors={formikBSubFormErrors}
                        setFormikBSubFormErrors={setFormikBSubFormErrors}
                        packageType={formikA.values?.package_type}
                        packageOrder={formikA.values?.package_order}
                        editData={
                          Object.keys(subFormValue).length ? subFormValue : null
                        }
                      />
                      {formikBSubFormValues.length !== 1 ? (
                        <div className="text-danger absolute mainbox-cls">
                          <sl-icon
                            library="lucide"
                            name="x-circle"
                            type="button"
                            size="large"
                            aria-hidden="true"
                            onClick={async () => {
                              await setFormikBSaveFlag(!formikBSaveFlag);
                              let tempAllFormValues = JSON.parse(
                                JSON.stringify(formikBSubFormValues)
                              );
                              let tempAllFormErrors = JSON.parse(
                                JSON.stringify(formikBSubFormErrors)
                              );
                              tempAllFormValues = tempAllFormValues.filter(
                                (item, itemIndex) => itemIndex !== index
                              );
                              tempAllFormErrors = tempAllFormErrors.filter(
                                (item, itemIndex) => itemIndex !== index
                              );
                              setFormikBSubFormValues([...tempAllFormValues]); // Ensure a new reference
                              setFormikBSubFormErrors([...tempAllFormErrors]);
                            }}
                          ></sl-icon>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
                {formikA?.values?.package_order === 0 ? <div className="w-full mt-1">
                  <button
                    type="button"
                    className="add-unit-btn ml-auto"
                    onClick={() => {
                      setFormikBSaveFlag(!formikBSaveFlag);

                      setFormikBSubFormValues([
                        ...formikBSubFormValues,
                        {
                          ...subFormInitialValues,
                          internal_id:
                            formikBSubFormValues?.sort(
                              (a, b) => b.internal_id - a.internal_id
                            )[0].internal_id + 1,
                        },
                      ]);
                    }}
                  >
                    <span> Add Unit</span> <img src={addIcon} alt="submit" />
                  </button>
                </div> : null}
              </div>
            </div>
          </div>
          <div className="pos-popup-footer">
            <button
              className="close btn-cancel"
              type="button"
              onClick={(e) => {
                setFormikBSaveFlag(!formikBSaveFlag);
                setCurrentPage("A");
              }}
            >
              <span className="back-btn">Back</span>
            </button>
            <button
              className="btn-submit"
              type="submit"
              onClick={() =>
                document
                  ?.getElementById("formikError")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              <span>Next</span> <img src={angleRightSvg} alt="submit" />
            </button>
          </div>
        </div>
      </form>
      <form
        className={currentPage === "C" ? `` : "displaynone"}
        onSubmit={formikC.handleSubmit}
      >
        <div className="pos-popup-container">
          <div className="pos-popup-header">
            <h3>
              Book Order{" "}
              <b>
                {localStorage.getItem("role") === roles.ops
                  ? null
                  : localStorage.getItem("name")}
              </b>
            </h3>
            <span className="close2">
              <img
                src={closeSvg}
                onClick={() => {
                  props.setShow(false);
                  formikC.resetForm();
                  setEditData(null);
                }}
                alt="Close"
              />
            </span>
          </div>
          <div className="pos-popup-body">
            <div className="form-container">
              <div className="field-set-tree">
                <div class="progress-bar">
                  <div class="step active">
                    <div class="tabhead">Details</div>
                    <div class="numaric"></div>
                  </div>
                  <div class="step active">
                    <div class="tabhead">Add Unit</div>
                    <div class="numaric"></div>
                  </div>
                  <div class="step active">
                    <div class="tabhead">Payment Details</div>
                    <div class="numaric"></div>
                  </div>
                </div>
                {/* <h4>
                  <img src="images/ro-label-icon.svg" alt="" /> Payment Details
                </h4> */}
                {localStorage.getItem("role") === roles.ops ? (
                  <div className="bookPosition mb-4">
                    <div className="ind">
                      <h6>
                        Billing Type <span className="text-red-600">*</span>
                      </h6>
                      <Select
                        aria-label="Default select example"
                        name="billing"
                        placeholder="Select a Type"
                        onBlur={formikC.handleBlur}
                        value={defaultValue(
                          billingOptions,
                          formikC.values.billing
                        )}
                        onChange={(selected) => {
                          formikC.setFieldValue("billing", selected.value);
                          if (selected.value) {
                            formikC.setFieldValue("nonbillfile_url", "");
                            setNonBillFileUrl("");
                          }
                        }}
                        options={billingOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    </div>
                    {formikC.values.billing === 0 ? (
                      <div className="ind">
                        <h6>
                          Reason <span className="text-red-600">*</span>
                        </h6>
                        <input
                          type="file"
                          className="form-control"
                          aria-label=""
                          name="nonbill_file"
                          id="nonbill_file"
                          accept="application/pdf"
                          onChange={(e) => {
                            handleFileChange(e, "nonbillfile_url");
                          }}
                        />
                        {formikC.touched.nonbillfile_url &&
                          formikC.errors.nonbillfile_url && (
                            <span
                              id="formikError"
                              className="text-red-500 text-xs"
                            >
                              {formikC.errors.nonbillfile_url}
                            </span>
                          )}
                        {nonBillingFileProgress > 0 &&
                        nonBillingFileProgress < 100 ? (
                          <SlProgressBar
                            className="w-full"
                            value={nonBillingFileProgress}
                          >
                            {nonBillingFileProgress}%
                          </SlProgressBar>
                        ) : nonBillFileUrl ? (
                          <div className="d-flex gap-1 items-center mb-3">
                            <p className="text-xs text-blue-400 m-0">
                              {formikC.values.nonbillfile_url ||
                                nonBillFileUrl ||
                                "-"}
                            </p>
                            <sl-icon-button
                              title="View RO"
                              library="lucide"
                              name="view"
                              onClick={() => {
                                setViewPdf(true);
                                setPdfUrl(nonBillFileUrl);
                              }}
                            ></sl-icon-button>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                ) : null}

                <div className="bookPosition mb-4">
                  {localTypes.includes(new_user_type) ? (
                    <div className="ind">
                      <h6>
                        Payment Type <span className="text-red-600">*</span>
                      </h6>
                      <Select
                        aria-label="Default select example"
                        name="payment_type"
                        placeholder="Select a Type"
                        onBlur={formikC.handleBlur}
                        value={defaultValue(
                          slotPaymentTypeOptions,
                          formikC.values.payment_type
                        )}
                        onChange={(selected) => {
                          formikC.setFieldValue("payment_type", selected.value);
                          if (selected.value === 2)
                            formikC.setFieldValue("payment_method", 4);
                          else formikC.setFieldValue("payment_method", 0);
                        }}
                        options={slotPaymentTypeOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                      {formikC.touched.payment_type &&
                        formikC.errors.payment_type && (
                          <span
                            id="formikError"
                            className="text-red-500 text-xs"
                          >
                            {formikC.errors.payment_type}
                          </span>
                        )}
                    </div>
                  ) : null}
                  {formikC.values.payment_type === 1 ? (
                    <div className="ind">
                      <h6>
                        Payment Method <span className="text-red-600">*</span>
                      </h6>
                      <Select
                        aria-label="Default select example"
                        name="payment_method"
                        placeholder="Select a Type"
                        onBlur={formikC.handleBlur}
                        value={defaultValue(
                          slotPaymentMethodOptions,
                          formikC.values.payment_method
                        )}
                        onChange={(selected) => {
                          formikC.setFieldValue(
                            "payment_method",
                            selected.value
                          );
                          if (selected.value === 3)
                            formikC.setFieldValue("payment_id", "pay_");
                          else formikC.setFieldValue("payment_id", "");
                        }}
                        options={slotPaymentMethodOptions.filter(
                          (item) => item.value !== 4
                        )}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                      {formikC.touched.payment_method &&
                        formikC.errors.payment_method && (
                          <span
                            id="formikError"
                            className="text-red-500 text-xs"
                          >
                            {formikC.errors.payment_method}
                          </span>
                        )}
                    </div>
                  ) : null}
                  {formikC.values.payment_type === 3 ? (
                    <div className="ind">
                      <h6>
                        PDC File <span className="text-red-600">*</span>
                      </h6>
                      <input
                        type="file"
                        className="form-control"
                        aria-label=""
                        name="pdcfile_url"
                        id="pdcfile_url"
                        accept="application/pdf"
                        onChange={(e) => {
                          handleFileChange(e, "pdcfile_url");
                        }}
                      />
                      {formikC.touched.pdcfile_url &&
                        formikC.errors.pdcfile_url && (
                          <span
                            id="formikError"
                            className="text-red-500 text-xs"
                          >
                            {formikC.errors.pdcfile_url}
                          </span>
                        )}
                      {pdcFileprogress > 0 && pdcFileprogress < 100 ? (
                        <SlProgressBar
                          className="w-full"
                          value={pdcFileprogress}
                        >
                          {pdcFileprogress}%
                        </SlProgressBar>
                      ) : pdcFileUrl ? (
                        <div className="d-flex gap-1 items-center mb-3">
                          <p className="text-xs text-blue-400 m-0">
                            {formikC.values.pdcfile_url || pdcFileUrl || "-"}
                          </p>
                          <sl-icon-button
                            title="View RO"
                            library="lucide"
                            name="view"
                            onClick={() => {
                              setViewPdf(true);
                              setPdfUrl(pdcFileUrl);
                            }}
                          ></sl-icon-button>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div className="ind">
                      <h6>
                      Deal Type <span className="text-red-600">*</span>
                      </h6>
                      <Select
                        aria-label="Default select example"
                        name="deal_type"
                        placeholder="Select a Type"
                        onBlur={formikC.handleBlur}
                        value={defaultValue(
                          dealTypeOptions,
                          formikC.values.deal_type
                        )}
                        onChange={(selected) => {
                          formikC.setFieldValue(
                            "deal_type",
                            selected.value
                          );
                        }}
                        options={dealTypeOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                      {formikC.touched.deal_type &&
                        formikC.errors.deal_type && (
                          <span
                            id="formikError"
                            className="text-red-500 text-xs"
                          >
                            {formikC.errors.deal_type}
                          </span>
                        )}
                    </div>
                </div>
                <div className="bookPosition mb-4">
                  <div className="ind">
                    <h6>
                      {new_user_type === 1
                        ? "RO No"
                        : "Razorpay ID / Transaction ID / Postpaid RO.no / PG Id"}
                      <span className="text-red-600">*</span>
                    </h6>
                    <input
                      type="text"
                      name="payment_id"
                      onChange={formikC.handleChange}
                      onBlur={formikC.handleBlur}
                      value={formikC.values.payment_id}
                      className="border_bottom w-full"
                    />
                    {formikC.touched.payment_id &&
                      formikC.errors.payment_id && (
                        <span id="formikError" className="text-red-500 text-xs">
                          {formikC.errors.payment_id}
                        </span>
                      )}
                  </div>
                </div>
                {new_user_type === 5 ? (
                  <div className="bookPosition">
                    <div className="ind force_w_full">
                      <h6>Package Details: </h6>
                      <div className="d-flex items-center justify-between pb-1">
                        {slotPackagesOptions.map((item) => {
                          return (
                            <span
                              className="d-flex flex-col gap-2 justify-center items-center w-1/5 "
                              htmlFor={`package1${item.value}`}
                            >
                              {item.label}
                              <span className="py-4 bg-slate-100 w-full d-flex justify-center">
                                <input
                                  type="radio"
                                  value={item.value}
                                  onChange={formikC.handleChange}
                                  onBlur={formikC.handleBlur}
                                  name="package_no"
                                  id={`package1${item.value}`}
                                  checked={
                                    formikC.values.package_no ===
                                    "" + item.value
                                  }
                                />
                              </span>
                            </span>
                          );
                        })}
                      </div>
                      {formikC.touched.package_no &&
                        formikC.errors.package_no && (
                          <span className="text-red-500 text-xs">
                            {formikC.errors.package_no}
                          </span>
                        )}
                      {/* {formikC.values.package_no && daysMismatched ? (
                          <span className="text-red-500 text-xs">
                            {"Date Range Doesn't Match with Package"}
                          </span>
                        ) : null} */}
                    </div>
                  </div>
                ) : null}

                <h4>
                  <img src="images/ro-label-icon.svg" alt="" /> Upload Ro &amp;
                  Value
                </h4>
                <div className="dragUpload">
                  <img src="images/uploaded-icon.svg" alt="" />
                  <div className="uploadBtn">
                    <input
                      type="file"
                      className="form-control"
                      aria-label=""
                      name="ro_File"
                      id="ro_file"
                      accept="application/pdf"
                      onChange={(e) => {
                        handleFileChange(e, "rofile_url");
                      }}
                    />
                    <button>
                      <i className="icon">
                        <img src="images/attach-icon.svg" alt="" />
                      </i>
                      Browse Files
                    </button>
                  </div>
                  <h1>
                    Drag &amp; Drop your local files to upload
                    <span>Supported files: PDF, DOC, WEBP, PNG and JPG</span>
                  </h1>
                </div>
                {progress > 0 && progress < 100 ? (
                  <SlProgressBar className="w-full" value={progress}>
                    {progress}%
                  </SlProgressBar>
                ) : roFileUrl ? (
                  <div className="d-flex gap-1 items-center mb-3">
                    <p className="text-xs text-blue-400 m-0">
                      {formikC.values.rofile_url || roFileUrl || "-"}
                    </p>
                    <sl-icon-button
                      title="View RO"
                      library="lucide"
                      name="view"
                      onClick={() => {
                        setViewPdf(true);
                        setPdfUrl(roFileUrl);
                      }}
                    ></sl-icon-button>
                  </div>
                ) : null}
                {formikC.touched.rofile_url && formikC.errors.rofile_url && (
                  <span id="formikError" className="text-red-500 text-xs mb-3">
                    {formikC.errors.rofile_url}
                  </span>
                )}
                {/* Image Upload */}
                <h4 className="mt-6">
                  <img src="images/uploaded-icon.svg" alt="" /> Upload Image (Optional)
                </h4>
                <div className="dragUpload">
                  <img src="images/uploaded-icon.svg" alt="" />
                  <div className="uploadBtn">
                    <input
                      type="file"
                      className="form-control"
                      aria-label=""
                      name="creative_image"
                      id="creative_image"
                      accept="image/jpeg,image/png,image/jpg,image/webp"
                      onChange={(e) => {
                        if (e.target.files.length) {
                          const formData = new FormData();
                          formData.append("files", e.target.files[0]);
                          uploadroFile(formData, "creative_image");
                        }
                      }}
                    />
                    <button type="button">
                      <i className="icon">
                        <img src="images/attach-icon.svg" alt="" />
                      </i>
                      Browse Image
                    </button>
                  </div>
                  <h1>
                    Drag & Drop your Image
                    <span>Supported: JPG, PNG, JPEG, WEBP</span>
                  </h1>
                </div>

                {/* Progress Bar */}
                {creativeImageProgress > 0 && creativeImageProgress < 100 ? (
                  <SlProgressBar className="w-full mt-2" value={creativeImageProgress}>
                    {creativeImageProgress}%
                  </SlProgressBar>
                ) : creativeImageUrl ? (
                  <div className="d-flex gap-2 items-center mt-3 flex-wrap">
                    <img
                      src={creativeImageUrl}
                      alt="Creative"
                      className="h-24 rounded border object-cover"
                    />
                    <div>
                      <p className="text-xs text-blue-400 m-0 break-all max-w-md">
                        {creativeImageUrl}
                      </p>
                      <sl-icon-button
                        library="lucide"
                        name="view"
                        title="View Full Size"
                        onClick={() => window.open(creativeImageUrl, "_blank")}
                      ></sl-icon-button>
                      <sl-icon-button
                        library="lucide"
                        name="x-circle"
                        title="Remove"
                        onClick={() => {
                          setCreativeImageUrl(null);
                          formikC.setFieldValue("image_url", "");
                          setCreativeImageProgress(0);
                        }}
                      ></sl-icon-button>
                    </div>
                  </div>
                ) : null}
                <div className="budget-tltp">
                  <h6>
                    Enter Value in Rupees ( Without GST ){" "}
                    <span className="text-red-600">*</span>
                  </h6>
                  <span class="tooltip-wrapper">
                    <span class="tooltip" flow="right">
                      <div class="tooltip-content">
                        <div class="heading">Order Value</div>
                        <div class="content">
                          <div class="logintracker">
                            <span>Order Value should match with Individual Ad Units Budget</span>
                          </div>
                        </div>
                      </div>
                      <div class="tooltip-arrow"></div>
                    </span>
                    <img src={exclamatorIcon} width={"25px"}/>
                  </span>
                </div>
                <div className="roValue  mb-3">
                  <input
                    type="number"
                    name="ro_value"
                    id="ro-value"
                    placeholder="Ex: 1,50,000"
                    onChange={formikC.handleChange}
                    onBlur={formikC.handleBlur}
                    value={formikC.values.ro_value}
                  />
                  {/* <p>
                      Per Day:{" "}
                      {formikC.values.ro_value &&
                      formikC.values.date_ranges?.length ? (
                        <span>
                          {(
                            +formikC.values.ro_value /
                            (+getNumberOfDaysForNormalDays(
                              formikC.values.date_ranges
                            ) || 1)
                          ).toFixed(2)}{" "}
                          Rupees Only
                        </span>
                      ) : (
                        ""
                      )}
                    </p> */}
                  <p>
                    OverAll In Words:{" "}
                    {formikC.values.ro_value ? (
                      <span>
                        {convertToWords(formikC.values.ro_value)} Rupees Only
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
                {formikC.touched.ro_value && formikC.errors.ro_value && (
                  <span id="formikError" className="text-red-500 text-xs mb-3">
                    {formikC.errors.ro_value}
                  </span>
                )}

                <div className="bookPosition">
                  <div className="ind force_w_full">
                    <h6>Description:</h6>
                    <textarea
                      className="description"
                      type="text"
                      name="description"
                      id="description"
                      placeholder="Enter Description"
                      onChange={formikC.handleChange}
                      onBlur={formikC.handleBlur}
                      value={formikC.values.description}
                    />

                    {formikC.touched.description &&
                      formikC.errors.description && (
                        <span className="text-red-500 text-xs">
                          {formikC.errors.description}
                        </span>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pos-popup-footer">
            <button
              className="close btn-cancel"
              type="button"
              onClick={() => {
                setCurrentPage("B");
                setSubmitLoader(false)
              }}
            >
              <span className="back-btn">Back</span>
            </button>
            <button
              className="btn-submit"
              type="submit"
              onClick={() =>
                document
                  ?.getElementById("formikError")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              disabled={submitLoader}
            >
              <span>Submit</span> <img src={angleRightSvg} alt="submit" />
            </button>
          </div>
        </div>
      </form>

      {viewPdf && (
        <PdfViewer url={pdfUrl} show={viewPdf} setShow={setViewPdf} />
      )}
    </div>
  );
}

export default BookSlot;

// showShortcuts={true}
// configs={{
//   shortcuts: {
//     today: "today",
//     tomorrow: {
//       text: "Tomorrow",
//       period: {
//         start: new Date(
//           new Date().setDate(new Date().getDate() + 1)
//         ),
//         end: new Date(
//           new Date().setDate(new Date().getDate() + 1)
//         ),
//       },
//     },
//     next8Days: {
//       text: "Next 8 days",
//       period: {
//         start: new Date(
//           new Date().setDate(new Date().getDate() + 1)
//         ),
//         end: new Date(
//           new Date().setDate(new Date().getDate() + 8)
//         ),
//       },
//     },
//     nextMonth: {
//       text: "Next Month",
//       period: {
//         start: new Date(
//           new Date().getFullYear(),
//           new Date().getMonth() + 1,
//           1
//         ),
//         end: new Date(
//           new Date().getFullYear(),
//           new Date().getMonth() + 2,
//           0
//         ),
//       },
//     },
//   },
// }}
